import {Box} from '@mui/material';
import styled from 'styled-components';

export const CloseScheduleItem = styled(Box)`
    color: red;
`;
